import { CircleLoader } from '@proton/atoms';

const Loader = () => {
    return <CircleLoader className="color-primary" size="large" />;
};

export default Loader;
